import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { fileToJpegBase64 } from "@/lib/veeder";

export const MAX_HELP_PHOTOS = 3;

export function HelpPhotoButton({ photos, setPhotos, busy, setBusy, onError, disabled, t }) {
  const input = useRef(null);
  const add = async (files) => {
    const list = Array.from(files || []).slice(0, MAX_HELP_PHOTOS - photos.length);
    if (!list.length) return;
    setBusy(true);
    for (const f of list) {
      try {
        const [b64, thumb] = await Promise.all([fileToJpegBase64(f, 1600), fileToJpegBase64(f, 160)]);
        const { photo_id } = await api.uploadPhoto(b64);
        setPhotos((p) => [...p, { id: photo_id, preview: `data:image/jpeg;base64,${thumb}` }].slice(0, MAX_HELP_PHOTOS));
      } catch (e) { onError(apiError(e) || t("Couldn't add that photo. Try another one.")); }
    }
    setBusy(false);
    if (input.current) input.current.value = "";
  };
  return (
    <>
      <button type="button" className="mic-btn" data-testid="help-photo-button" aria-label={t("Add photo")}
        disabled={disabled || busy || photos.length >= MAX_HELP_PHOTOS} onClick={() => input.current?.click()}>
        {busy ? <Loader2 size={18} className="spin" /> : <Camera size={18} />}
      </button>
      <input ref={input} type="file" accept="image/*" multiple hidden data-testid="help-photo-input" onChange={(e) => add(e.target.files)} />
    </>
  );
}

export function PendingPhotos({ photos, setPhotos, t }) {
  if (!photos.length) return null;
  return (
    <div className="photo-row help-pending" data-testid="help-pending-photos">
      {photos.map((p, i) => (
        <div key={p.id} className="photo-thumb photo-thumb-sm" data-testid={`help-pending-photo-${i}`}>
          <img src={p.preview} alt="" />
          <button type="button" aria-label={t("Remove photo")} data-testid={`help-pending-remove-${i}`}
            onClick={() => setPhotos(photos.filter((x) => x.id !== p.id))}><X size={12} /></button>
        </div>
      ))}
    </div>
  );
}
